import CalComDialog from "../../components/calComDialog/calComDialog.jsx";
import ConsultationInterstitialLayout from "./consultationInterstitial/ConsultationInterstitialLayout.jsx";
import { CAL_COM_KFT_URL } from "./consultationInterstitial/calComKftUrl.js";
import { KFT_INTERSTITIAL_OPTIONS } from "./consultationInterstitial/kftInterstitialOptions.js";

/**
 * Shown right after a manual company-type pick resolves to "kft" — offers a
 * choice between booking a consultation and continuing the manual flow.
 * "Consultation" opens Nina's Cal.com booking page in a dialog (owned by the
 * parent flow controller, opened when Next is pressed) — no in-app day/slot
 * picker.
 */
const CommonKftInterstitial = ({
  selection,
  onSelectionChange,
  bookingDialogOpen,
  onBookingDialogOpenChange,
}) => {
  return (
    <>
      <ConsultationInterstitialLayout
        titleKey="searchflow.kftinterstitialtitle"
        subtitleKey="searchflow.kftinterstitialsubtitle"
        options={KFT_INTERSTITIAL_OPTIONS}
        selection={selection}
        onSelectionChange={onSelectionChange}
      />
      <CalComDialog
        open={bookingDialogOpen}
        onClose={() => onBookingDialogOpenChange(false)}
        url={CAL_COM_KFT_URL}
      />
    </>
  );
};

export default CommonKftInterstitial;
